import React from "react";
import "./Greeting.css";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import { greeting } from "../../portfolio";
import { Fade } from "react-reveal";

export default function Greeting(props) {
  const theme = props.theme;
  return (
    <Fade bottom duration={1000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div className="greeting-name">
              <h1 className="greeting-text" style={{ color: theme.text }}>
                {greeting.title}
              </h1>
              {greeting.pronouns && (
                <h2 className="greeting-pronouns" style={{ color: theme.text }}>
                  ( {greeting.pronouns} )
                </h2>
              )}
            </div>
            <div className="greeting-desc">
              <p
                className="greeting-text-p subTitle"
                style={{ color: theme.secondaryText }}
              >
                {greeting.subTitle}
              </p>
              <SocialMedia theme={theme} />
              <div className="portfolio-repo-btn-div">
                <Button
                  text="⭐ See my Resume"
                  newTab={true}
                  href={greeting.resumeLink}
                  theme={theme}
                  className="portfolio-repo-btn"
                />
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            {
              <img
                alt="Pratik"
                src={require(`../../assests/images/pratik.jpeg`)}
                // src={require(`../../assests/images/${greeting?.image_path}`)}
                width="500"
                height="600"
              ></img>
            }
          </div>
        </div>
      </div>
    </Fade>
  );
}
